module.exports = __webpack_public_path__ + "img/[困].0af78697.svg";